import { render, staticRenderFns } from "./KompasContainer.vue?vue&type=template&id=48be00ae&"
import script from "./KompasContainer.vue?vue&type=script&lang=js&"
export * from "./KompasContainer.vue?vue&type=script&lang=js&"
import style0 from "./KompasContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports